import { useViewStore } from '../../stores/viewStore'

export default function ExplodeSlider() {
  const explodeValue = useViewStore((s) => s.explodeValue)
  const setExplode = useViewStore((s) => s.setExplode)

  return (
    <div className="explode-slider">
      <div className="panel-section__title">Explode</div>
      <input
        type="range"
        min={0}
        max={1}
        step={0.01}
        value={explodeValue}
        onChange={(e) => setExplode(Number(e.target.value))}
        className="explode-slider__input"
      />
      <span className="explode-slider__value">{Math.round(explodeValue * 100)}%</span>
    </div>
  )
}
